import moment from "moment";
import "./ModalAcompanhamentoVisitaDetalheAtividade.css";
import Modal from "react-modal/lib/components/Modal";
import UploadArquivos from "../../../../componentes/UploadArquivos/UploadArquivos";
import { useRef } from "react";
import TabItem from "../../../../componentes/tabItem/tabitem";

function fixEncoding(str) {
    if (!str) return str;
    try {
        return decodeURIComponent(escape(str));
    } catch {
        return str;
    }
}
function ModalAcompanhamentoVisitaDetalheAtividade(props){
    const uploadRef = useRef();  
    const atividade = props.atividadeSelecionada ?? {};

    return(
        <>
        <Modal
                    isOpen={props.isOpen}
                    onRequestClose={props.onRequestClose}
                    overlayClassName="atividade-modal-overlay"
                    ariaHideApp={false}
                    className="atividade-modal-content"
                > 

            <div className="bsmodal-header atividade-modal-header">
                    <div>
                        <h3 className="modal-title bolt atividade-modal-title">Detalhamento da Atividade</h3>
                        <div className="atividade-modal-subtitle">
                            Visita {atividade.id_visita || "-"} • Evidência {atividade.id_evidencia || "-"}
                        </div>
                    </div>
                    <div className="atividade-modal-header-badge">
                        {atividade.data ? moment(atividade.data).format("DD/MM/YYYY") : "Sem data"}
                    </div>
                </div>

            <div className="detalhe-atividade-body">
                <div className="atividade-resumo-panel mb-3">
                    <div className="atividade-resumo-item">
                        <span className="atividade-resumo-label">Promotor</span>
                        <strong className="atividade-resumo-value">
                            {atividade.id_promotor || atividade.promotor
                                ? `${atividade.id_promotor ?? ""}${atividade.id_promotor && atividade.promotor ? " - " : ""}${atividade.promotor ?? ""}`
                                : "Sem informação"}
                        </strong>
                        <span className="atividade-resumo-meta">Identificação do promotor</span>
                    </div>
                    <div className="atividade-resumo-item">
                        <span className="atividade-resumo-label">Atividade</span>
                        <strong className="atividade-resumo-value">{atividade.atividade || "Sem descrição"}</strong>
                        <span className="atividade-resumo-meta">Visita {atividade.id_visita ?? "-"}</span>
                    </div>
                    <div className="atividade-resumo-item">
                        <span className="atividade-resumo-label">Data</span>
                        <strong className="atividade-resumo-value">
                            {atividade.data ? moment(atividade.data).format("DD/MM/YYYY") : "Sem data"}
                        </strong>
                        <span className="atividade-resumo-meta">Evidência {atividade.id_evidencia ?? "-"}</span>
                    </div>
                    <div className="atividade-resumo-item">
                        <span className="atividade-resumo-label">Status</span>
                        <strong className="atividade-resumo-value">{atividade.realizado ?? "-"}</strong>
                        <span className="atividade-resumo-meta">Realização da atividade</span>
                    </div>
                    <div className="atividade-resumo-item">
                        <span className="atividade-resumo-label">Venda</span>
                        <strong className="atividade-resumo-value">{atividade.houvevenda ?? "-"}</strong>
                        <span className="atividade-resumo-meta">Se aplicável</span>
                    </div>
                    <div className="atividade-resumo-item">
                        <span className="atividade-resumo-label">Quiz</span>
                        <strong className="atividade-resumo-value">{atividade.fezquiz ? "Sim" : "Não"}</strong>
                        <span className="atividade-resumo-meta">Participação no quiz</span>
                    </div>
                </div>

                <div className="row g-3">
                    <div className="col-12 col-xl-4">
                        <div className="atividade-section-card h-100">
                            <div className="atividade-section-title">Promotor</div>
                            <label htmlFor="Promotor" className="mb-1">Promotor</label>
                            <input
                                disabled
                                type="text"
                                className="form-control"
                                id="Promotor"
                                value={
                                    atividade.id_promotor || atividade.promotor
                                        ? `${atividade.id_promotor ?? ""}${atividade.id_promotor && atividade.promotor ? " - " : ""}${atividade.promotor ?? ""}`
                                        : ""
                                }
                            />
                        </div>
                    </div>

                    <div className="col-12 col-xl-8">
                        <div className="atividade-section-card h-100">
                            <div className="atividade-section-title">Atividade</div>
                            <div className="row g-2 atividade-card-grid">
                                <div className="col-12 col-md-6">
                                    <label htmlFor="Visita" className="mb-1">Visita</label>
                                    <input disabled type="text" className="form-control" id="Visita" value={atividade.id_visita ?? ""} />
                                </div>
                                <div className="col-12 col-md-6">
                                    <label htmlFor="Evidencia" className="mb-1">Evidência</label>
                                    <input disabled type="text" className="form-control" id="Evidencia" value={atividade.id_evidencia ?? ""} />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="Atividade" className="mb-1">Atividade</label>
                                    <input disabled type="text" className="form-control" id="Atividade" value={atividade.atividade ?? ""} />
                                </div>
                                <div className="col-12 col-md-4">
                                    <label htmlFor="Data" className="mb-1">Data</label>
                                    <input
                                        disabled
                                        type="text"
                                        className="form-control"
                                        id="Data"
                                        value={atividade.data ? moment(atividade.data).format("DD/MM/YYYY") : ""}
                                    />
                                </div>
                                {atividade.realizado != null && (
                                    <div className="col-12 col-md-4">
                                        <label htmlFor="realizado" className="mb-1">Realizado?</label>
                                        <input disabled type="text" className="form-control" id="realizado" value={atividade.realizado ?? ""} />
                                    </div>
                                )}
                                {atividade.equipe != null && atividade.equipe !== "" && (
                                    <div className="col-12 col-md-4">
                                        <label htmlFor="Equipe" className="mb-1">Equipe</label>
                                        <input disabled type="text" className="form-control" id="Equipe" value={atividade.equipe ?? ""} />
                                    </div>
                                )}
                                {atividade.qtpessoas != null && atividade.qtpessoas !== "" && (
                                    <div className="col-12 col-md-4">
                                        <label htmlFor="QtdePessoas" className="mb-1">Qtde. Pessoas</label>
                                        <input disabled type="text" className="form-control" id="QtdePessoas" value={atividade.qtpessoas ?? ""} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {atividade.veterinario != null && (
                        <div className="col-12 col-lg-6">
                            <div className="atividade-section-card h-100">
                                <div className="atividade-section-title">Veterinário</div>
                                <div className="row g-2">
                                    <div className="col-md-8">
                                        <label htmlFor="Veterinario" className="mb-1">Veterinário</label>
                                        <input disabled type="text" className="form-control" id="Veterinario" value={atividade.veterinario ?? ""} />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="Contato" className="mb-1">Contato</label>
                                        <input disabled type="text" className="form-control" id="Contato" value={atividade.telefone ?? ""} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {atividade.houvevenda != null && (
                        <div className="col-12 col-lg-6">
                            <div className="atividade-section-card h-100">
                                <div className="atividade-section-title">Venda</div>
                                <label htmlFor="houvevenda" className="mb-1">Realizado Venda?</label>
                                <input disabled type="text" className="form-control" id="houvevenda" value={atividade.houvevenda ?? ""} />
                            </div>
                        </div>
                    )}

                    {atividade.fezquiz != null && atividade.fezquiz !== "" && (
                        <div className="col-12 col-lg-4">
                            <div className="atividade-section-card h-100">
                                <div className="atividade-section-title">Quiz</div>
                                <label htmlFor="quiz" className="mb-1">Fez Quiz?</label>
                                <input disabled type="text" className="form-control" id="quiz" value={atividade.fezquiz ?? ""} />
                            </div>
                        </div>
                    )}

                    <div className="col-12">
                        <TabItem 
                            disabled
                            idvisita={atividade.id_visita}  
                            idatividade={atividade.id_atividade}
                            idevidencia={atividade.id_evidencia}        
                        />
                    </div>

                    <div className="col-12 col-xl-6">
                        <div className="atividade-section-card h-100">
                            <div className="atividade-section-title">Fotos</div>
                            <UploadArquivos 
                                ref={uploadRef} 
                                idRotina={"3001.1"}
                                idRelacional={`${atividade.id_visita ?? ""}${atividade.id_atividade ?? ""}${atividade.id_evidencia ?? ""}`}
                                acceptTypes="image/*"
                                capture={true}
                                disabled
                            /> 
                        </div>
                    </div>

                    <div className="col-12 col-xl-6">
                        <div className="atividade-section-card h-100">
                            <div className="atividade-section-title">Comentário</div>
                            <textarea
                                disabled
                                className="form-control atividade-comentario"
                                id="Comentario"
                                rows="10"
                                placeholder="Não foi realizado comentário..."
                                value={fixEncoding(atividade.comentario) ?? ""}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="bsmodal-footer atividade-modal-footer" style={{ justifyContent: 'flex-start' }}>
                    <button
                        onClick={props.onRequestClose}
                        type="button"
                        className="btn btn-secondary px-4"
                    >
                        Voltar
                    </button>
            </div>
        </Modal>
        </>
    );
}

export default ModalAcompanhamentoVisitaDetalheAtividade;